import { page_dashboard } from "./pages/dashboard.js";
import { page_log } from "./pages/log.js";
import { page_errors } from "./pages/errors.js";
import { page_login } from "./pages/login.js";
import { page_register } from "./pages/register.js";
import { page_setup } from "./pages/setup.js";
import { page_sub } from "./pages/subscriptions.js";
import { page_payments } from "./pages/payments.js";
import { page_strategy } from "./pages/strategy.js";
import { page_admin_payments } from "./pages/admin/payments.js";
import { page_admin_users } from "./pages/admin/users.js";
import { page_publications } from "./pages/publications.js";
import { page_enlistments } from "./pages/enlistments.js";
import { page_fallback } from "./pages/page_fallback.js";
// /user/19/log
const routeMap = {
    "/login": page_login,
    "/register": page_register,
    "/setup": page_setup,
    "/dashboard": page_dashboard,
    "/log": page_log,
    "/strategy": page_strategy,
    "/user/?": page_dashboard,
    "/user/?/strategy": page_strategy,
    "/subscriptions": page_sub,
    "/payments": page_payments,
    "/enlistments": page_enlistments,
    "/enlistments/?": page_enlistments,
    "/publications": page_publications,
    "/publications/?": page_publications,
    "/privacy": page_fallback,
    "/403": page_fallback,
    "/404": page_fallback,
    "/500": page_fallback,
    "/user/?/log": page_log,
    "/user/?/enlistments": page_enlistments,
    "/user/?/enlistments/?": page_enlistments,
    "/admin/payments": page_admin_payments,
    "/admin/users": page_admin_users,
    "/admin/users/?": page_dashboard,
    "/admin/errors": page_errors,
    "/admin/errors/?": page_errors,
};
export function loadPageScript() {
    const routeWithNumbers = location.pathname.split('/').filter(v => v !== undefined).join('/');
    const route = location.pathname.replace(/\/[0-9]+/g, '/?').split('/').filter(v => v !== undefined).join('/');
    if (route === '/') {
        return;
    }
    console.log('Loading Page Script', route);
    if (!routeMap.hasOwnProperty(route) && !routeMap.hasOwnProperty(routeWithNumbers)) {
        console.error(`Route not Found! route=`, route);
        modalService.create({
            title: 'Whoopsie!',
            content: 'Deze pagina heeft een error!'
        });
        return Promise.resolve();
    }
    return Promise.resolve().then(_ => { var _a; return ((_a = routeMap[route]) !== null && _a !== void 0 ? _a : routeMap[routeWithNumbers]).run(); });
}
//# sourceMappingURL=routes.js.map